import { LoginFormData } from './formSchema';

export const defaultInitialValues: LoginFormData = {
  username: '',
  isLoginSubAccount: false,
  subAccountUsername: '',
  password: '',
};
